/**
 * Phase 1: 認証チェック、キャンペーンデータ取得、ポップアップデータ取得、
 * マスタ更新チェック を並列実行
 *
 * campaign / popup / masterUpdate は認証不要（getWithoutAuth）なので、
 * checkAuth と同時に取得できる。
 * 全サブステートが final に到達したら phase2Parallel へ遷移する。
 */
export const phase1Config = {
  type: 'parallel' as const,
  states: {
    // 1.A 認証チェック
    auth: {
      initial: 'checking' as const,
      states: {
        checking: {
          invoke: {
            src: 'checkAuth' as const,
            onDone: {
              target: 'done' as const,
              actions: 'assignAuthResult' as const,
            },
            onError: {
              target: 'done' as const,
            },
          },
        },
        done: { type: 'final' as const },
      },
    },

    // 1.B キャンペーンデータ取得（認証不要なので認証と同時に先行取得）
    // queryClient.fetchQuery() 経由で TanStack Query のキャッシュを活用する。
    campaign: {
      initial: 'fetching' as const,
      states: {
        fetching: {
          invoke: {
            src: 'fetchCampaign' as const,
            onDone: {
              target: 'done' as const,
              actions: 'assignCampaignResult' as const,
            },
            onError: 'failed' as const,
          },
        },
        done: { type: 'final' as const },
        failed: { type: 'final' as const },
      },
    },

    // 1.C ポップアップデータ取得（認証不要なので認証・キャンペーンと同時に先行取得）
    // queryClient.fetchQuery() 経由で TanStack Query のキャッシュを活用する（1日キャッシュ）。
    // isConfirmModalExists もここで確定させる（localStorage + popup['HOME'] を両方見る）。
    popup: {
      initial: 'fetching' as const,
      states: {
        fetching: {
          invoke: {
            src: 'fetchPopup' as const,
            onDone: {
              target: 'done' as const,
              actions: 'assignPopupResult' as const,
            },
            onError: 'done' as const,
          },
        },
        done: { type: 'final' as const },
      },
    },

    // 1.D マスタデータ更新チェック（認証不要なので auth/campaign/popup と同時に先行取得）
    // 失敗してもフロー継続（onError → done）。
    masterUpdate: {
      initial: 'fetching' as const,
      states: {
        fetching: {
          invoke: {
            src: 'fetchMasterUpdate' as const,
            onDone: 'done' as const,
            onError: 'done' as const,
          },
        },
        done: { type: 'final' as const },
      },
    },
  },
  onDone: 'phase2Parallel' as const,
}
